import { FlexRow, ReadonlyLabel, ReadonlyBlock, TextButton } from '@/forms-legacy'

import { Triangle } from './Triangle'

interface Props {
  title: string
  description?: string
  collapsed: boolean
  onToggle: () => void
  testId?: string
}

export function GpsDataViewToggler(props: Props) {
  const { title, description, collapsed, onToggle, testId = 'gps-data-toggler' } = props

  return (
    <>
      <TextButton
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={onToggle}
        data-testid={testId}
        data-trackid={testId}
      >
        <FlexRow style={{ marginTop: 20 }} justifyContent="space-between">
          <ReadonlyLabel style={{ marginBottom: 0 }} primary>
            {title}
          </ReadonlyLabel>
          <Triangle style={{ transform: `rotate(${collapsed ? '180deg' : '0deg'})` }} />
        </FlexRow>
      </TextButton>
      {!!description && (
        <FlexRow>
          <ReadonlyBlock>
            <ReadonlyLabel small>{description}</ReadonlyLabel>
          </ReadonlyBlock>
        </FlexRow>
      )}
    </>
  )
}
